import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { extractErrorMessage } from '../../utils/apiErrors';
import SitesEditor from './SitesEditor';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const toForm = (c) => ({ name: c?.name || '', sites: (c?.sites || []).map((s) => ({ ...s })) });

export default function CustomerFormDialog({ open, onOpenChange, customer, onSaved }) {
  const [formData, setFormData] = useState(toForm(customer));

  useEffect(() => { if (open) setFormData(toForm(customer)); }, [open, customer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { name: formData.name, sites: formData.sites.filter((s) => s.name.trim() || s.lsd.trim() || (s.address || '').trim() || Object.values(s.components || {}).some(Boolean)) };
    try {
      let saved;
      if (customer) {
        saved = (await axios.patch(`${API}/customers/${customer.id}`, payload)).data;
        toast.success('Customer updated');
      } else {
        saved = (await axios.post(`${API}/customers`, payload)).data;
        toast.success('Customer added');
      }
      onOpenChange(false);
      onSaved?.(saved);
    } catch (error) {
      toast.error(extractErrorMessage(error, 'Failed to save customer'));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="grid-cols-[minmax(0,1fr)] max-h-[90vh] overflow-y-auto overflow-x-hidden sm:max-w-xl" data-testid="customer-form-dialog">
        <DialogHeader>
          <DialogTitle>{customer ? 'Edit Customer' : 'Add New Customer'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="customer-form">
          <div className="space-y-2">
            <Label>Customer Name</Label>
            <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required data-testid="customer-name-input" />
          </div>
          <SitesEditor value={formData.sites} onChange={(sites) => setFormData({ ...formData, sites })} testPrefix="customer-form-site" />
          <Button type="submit" className="w-full bg-slate-900 hover:bg-slate-800" data-testid="submit-customer-button">
            {customer ? 'Update Customer' : 'Add Customer'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
